import { useTranslation } from "react-i18next";
import { ApiKeysTable } from "@/features/apikeys/components/ApiKeysTable";
import { CreateApiKeyDialog } from "@/features/apikeys/components/CreateApiKeyDialog";

export function ApiKeysPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-lg font-medium">{t("apiKeys.title")}</h1>
          <p className="text-sm text-muted-foreground">{t("apiKeys.subtitle")}</p>
        </div>
        <CreateApiKeyDialog />
      </div>
      <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
        <ApiKeysTable />
      </div>
    </div>
  );
}
